var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "supsisText", attrs: { id: "supsis-text" } },
    [
      _vm.popover
        ? _c(
            "div",
            {
              staticClass: "supsis-popover",
              style: { left: _vm.left, bottom: _vm.bottom },
            },
            [
              _c("div", { staticClass: "rect" }),
              _vm._v(" "),
              _vm.copyText
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            zIndex: 9999999999,
                          },
                          expression:
                            "{\n                followCursor: true,\n                placement: 'bottom-end',\n                zIndex: 9999999999,\n            }",
                        },
                      ],
                      staticClass: "popover-item",
                      attrs: { content: "Seçili metni kopyala" },
                      on: { click: _vm.copyContent },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("content_copy"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.createTask
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            zIndex: 9999999999,
                          },
                          expression:
                            "{\n                followCursor: true,\n                placement: 'bottom-end',\n                zIndex: 9999999999,\n            }",
                        },
                      ],
                      staticClass: "popover-item",
                      attrs: { content: "Seçili metin üzerine görev oluştur" },
                      on: { click: _vm.createTaskModal },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("add_task"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.createEvent
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            zIndex: 9999999999,
                          },
                          expression:
                            "{\n                followCursor: true,\n                placement: 'bottom-end',\n                zIndex: 9999999999,\n            }",
                        },
                      ],
                      staticClass: "popover-item",
                      attrs: { content: "Etkinlik oluştur" },
                      on: {
                        click: function ($event) {
                          _vm.newEventModalVisible = true
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("edit_calendar"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("items"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "supsisTextContent" }, [_vm._t("content")], 2),
      _vm._v(" "),
      _vm.newEventModalVisible
        ? _c("CreateEventModal", {
            attrs: {
              eventSummary: _vm.getSummary(),
              calendarList: _vm.calendarList,
            },
            on: {
              close: function ($event) {
                _vm.newEventModalVisible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }